import apiClient from '../apiClient'

const BASE_URL = '/inquiry'

const inquiryAPI = {
  // 문의 목록 조회
  getInquiries: params => apiClient.get(BASE_URL, { params }),

  // 대분류 카테고리 조회
  getCategories: () => apiClient.get(`${BASE_URL}/categories`),

  // 중분류 카테고리 조회
  getMidCategories: catId =>
    apiClient.get(`${BASE_URL}/midcategories/${catId}`),

  // 소분류 카테고리 조회
  getSubCategories: midcatId =>
    apiClient.get(`${BASE_URL}/subcategories/${midcatId}`),

  // 문의 등록
  createInquiry: formData =>
    apiClient.post(BASE_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),

  // 문의 상세 조회
  getInquiryDetail: id => apiClient.get(`${BASE_URL}/${id}`),

  // 문의 댓글 목록 조회
  getInquiryComments: id => apiClient.get(`${BASE_URL}/${id}/comments`),

  // 댓글 등록
  addComment: (inquiryId, formData) =>
    apiClient.post(`${BASE_URL}/${inquiryId}/comments`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),

  // 댓글 삭제
  deleteComment: (inquiryId, commentId) =>
    apiClient.delete(`${BASE_URL}/${inquiryId}/comments/${commentId}`),

  getCompletedDate: reqId => {
    return apiClient.get(`${BASE_URL}/history/completed/${reqId}`)
  },

  // 파일 다운로드
  downloadFile: (fileName, type = 'req') => {
    const endpoint = type === 'cmt' ? 'download/cmt' : 'download'
    return apiClient.get(`${BASE_URL}/${endpoint}/${fileName}`, {
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
  },

  // S3 파일 다운로드
  downloadS3File: (fileName, upload_year = null) => {
    const params = upload_year ? { upload_year } : {}
    return apiClient.get(`${BASE_URL}/download/s3/${fileName}`, {
      params,
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/octet-stream',
      },
    })
  },

  // 문의 수정
  updateInquiry: (id, formData) =>
    apiClient.put(`${BASE_URL}/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),

  // 문의 삭제
  deleteInquiry: id => apiClient.delete(`${BASE_URL}/${id}`),
}

export default inquiryAPI
